export default __webpack_public_path__ + "static/media/GoFundMe_logo.4bbced69.svg";